import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

@Injectable()
export class IISCompatibleUrlSerializer extends DefaultUrlSerializer {
    constructor() {
        super();
    }
    override serialize(tree: UrlTree): string {
        return super.serialize(tree).replace(/:/g, ','); // replace ":" with "," in the url
    }
    override parse(url: string): UrlTree {
        return super.parse(url.replace(/,/g, ':')); // replace "," back to ":" and let the original UrlSerializer do it's work
    }
}
